import React from 'react'
import styleButtonIcon from './ButtonIcon.module.scss'
import { Tooltip } from '../Tooltip'
import { Icon } from '../Icon'

export const ButtonIconView = (props: { tooltipText: string, iconName: string, iconColor: string, size: number, style: object, onClick?: () => void }): JSX.Element => {
  const {
    tooltipText,
    iconName,
    iconColor,
    size,
    style,
    onClick
  } = props

  return (
    <Tooltip text={tooltipText} style={{
      ...style,
      height: size,
      width: size,
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <div
        className={styleButtonIcon._}
        onClick={!!onClick && (() => { onClick() })}
        style={{ height: size, width: size }}
      >
        <Icon name={iconName} color={iconColor} size={size} />
      </div>
    </Tooltip>
  )
}
